
import { GCmembershipTypes as Type } from '../../types/gc-membership';
const initialState = {
  gcmembershipList: [],
  loading: false,
  error: null,
};

const GCmembershipListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.GET_GCMEMBERSHIP_LIST_REQUEST:
      return { ...state, loading: true, error: null, gcmembershipList: [] };

    case Type.GET_GCMEMBERSHIP_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        gcmembershipList: action.payload,
        loading: false,
      };
    case Type.GET_GCMEMBERSHIP_LIST_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false };
    default:
      return state;
  }
};

export default GCmembershipListReducer;